<form [formGroup]="form">
  @if (form.contains('primaryContactId')) {
    <rt-form-field margin-bottom>
      <rt-label
        >{{ t.primaryContactLabel | translate }}
        <rt-icon-help [rtTooltip]="t.primaryContactTooltip | translate" margin-left-small-x>
        </rt-icon-help
      ></rt-label>

      <rt-user-select-container
        [control]="$any(form.controls.primaryContactId)"
        (valueChange)="form.get('primaryContactId')?.setValue($event)"
      ></rt-user-select-container>
    </rt-form-field>
  }

  @if (form.contains('fullName')) {
    <rt-form-field margin-bottom>
      <rt-label>{{ t.fullNameLabel | translate }}</rt-label>
      <rt-input
        variant="rounded"
        formControlName="fullName"
        placeholder="{{ t.fullNamePlaceholder | translate }}"
      ></rt-input>
    </rt-form-field>
  }

  @if (form.contains('email')) {
    <rt-form-field margin-bottom>
      <rt-label>{{ t.emailLabel | translate }}</rt-label>
      <rt-input
        variant="rounded"
        formControlName="email"
        placeholder="{{ t.emailPlaceholder | translate }}"
      ></rt-input>
    </rt-form-field>
  }

  @if (form.contains('phone')) {
    <rt-form-field margin-bottom>
      <rt-label>{{ t.phoneLabel | translate }}</rt-label>
      <rt-phone-input
        [countryCode]="formValue.countryCode || null"
        [rtFormError]="phoneErrors"
        formControlName="phone"
        placeholder="{{ t.phonePlaceholder | translate }}"
      ></rt-phone-input>
    </rt-form-field>
  }

  @if (form.contains('invoiceEmails')) {
    <rt-divider margin-tb></rt-divider>

    <rt-form-field>
      <rt-label>{{ t.invoiceEmailsLabel | translate }}</rt-label>
      <rt-tagger
        [placeholder]="
          form.get('invoiceEmails')!.value.length === 0 ? 'john@example.com, anna@example.com' : ''
        "
        [control]="$any(form.get('invoiceEmails'))"
        [tags]="form.get('invoiceEmails')!.value"
        [markInvalid]="true"
        [preserveWhiteSpaces]="true"
        [applyStyleOnFocus]="true"
        variant="email"
      ></rt-tagger>
    </rt-form-field>
  }
</form>
